<div class="logs-signpost-custom-significance clr-wrapper">
    <ng-content></ng-content>

    <avi-dynamic-data-grid
        *ngIf="trafficLogsSignpostStore.logsSignificanceSignpostData$ | async as logsSignificanceSignpostData"
        class="logs-signpost-custom-significance__data-grid"
        [config]="significanceGroupsGridConfig"
        [rows]="logsSignificanceSignpostData"
        [rowsTotal]="logsSignificanceSignpostData.length"
    ></avi-dynamic-data-grid>
</div>

<div
    class="logs-signpost-custom-significance__loader clr-wrapper"
    *ngIf="trafficLogsSignpostStore.isLoading$ | async"
>
    <clr-spinner [clrMedium]="true"></clr-spinner>
</div>

<ng-template
    #nameFieldTemplateRef
    let-row
    let-index="index"
>
    <span
        class="logs-signpost-custom-significance__hide-overflow-content"
        *ngIf="row.value.isValid"
        logFilter
        [property]="row.value.param"
        [value]="row.value.value"
        [operator]="row.value?.contains ? FilterOperatorType.CONTAINS : FilterOperatorType.EQUAL_TO"
        (onFilterAdd)="trafficLogsSignpostStore.closeSignpost()"
        aviTitle="{{ row.value.display || row.value.value }}"
    >
        {{ row.value.display || row.value.value }}
    </span>
    <span
        *ngIf="!row.value.isValid"
        logFilterableEmptyField
        [property]="row.value.param"
        (onFilterAdd)="trafficLogsSignpostStore.closeSignpost()"
        class="logs-signpost-custom-significance__empty-field"
    ></span>
</ng-template>

<ng-template
    #progressBarFieldTemplateRef
    let-row
    let-index="index"
>
    <avi-progress-bar
        [percentage]="row.percentage"
        [hidePercentage]="true"
    ></avi-progress-bar>
</ng-template>
